<template>
  <div>
    <p class="text-xl font-light mb-6">Serving as a volunteer for many organizations in the Metuchen area, I have
        invested my
        personal time to
        contribute to the rich tapestry of community that exists in the Metuchen/Edison area.
    </p>
    <p class="text-xl font-light mb-6">From the arts, to our
        local library, pedestrian advocacy issues, family-building activities, and issues of local government, I am
        committed to the overall strength and stability of the community that I am proud to call home. As former
        executive director of the Metuchen Area Chamber of Commerce, I have intimate knowledge of our local economy. I
        also offer technical knowledge as I am certified by the State of New Jersey, Department of Community Affairs
        in “Land Use Law and Planning.”
    </p>
      <p class="text-xl font-light mb-6">Proximity to public transportation, highways, the
          Middlesex
          Greenway project
          for biking and walking, many
          arts and music programs for all ages, and a great mix of mom and pop shops combined with nationally recognized
          chains means you'd have the best of all worlds right here in Central New Jersey. I can help you find the place
          where you can flourish in Middlesex, Monmouth, and Union counties.</p>
      <p class="text-xl font-light mb-6">Buying, selling, or renting can be an intimidating process.
          I'll
          help you
          with enthusiasm and positivity to get the job done. Let me welcome you to your new home!</p>
  </div>
</template>

<script>
export default {
  name: 'AboutMe',
  components: {
  }
}
</script>
